/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreditCategoryResponse } from './CreditCategoryResponse';
export type CreditAllocationResponse = {
    validUntil: string | null;
    id: number;
    therapistId: number;
    clientId: number;
    categoryId: number;
    totalCredits: number;
    usedCredits: number;
    source: CreditAllocationResponse.source;
    packagePurchaseId: number | null;
    isActive: boolean;
    note: string | null;
    createdAt: string;
    category: CreditCategoryResponse | null;
};
export namespace CreditAllocationResponse {
    export enum source {
        PACKAGE = 'package',
        AGREEMENT = 'agreement',
        PRO_BONO = 'pro_bono',
        OTHER = 'other',
    }
}

